import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import {
    setLoading, loadItems
} from '../actions';
import * as constants from '../constants';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import MainContent from '../../../MainContent';

const { AgGridWithState } = core;

class KycGrid extends Component {

    state = {
        selectedIdRecord: 0,
        currentEditEntity: {},
        editFormVisible: false,
    }

    UNSAFE_componentWillMount() {
        this.props.loadLabels();
        this.props.loadItems();
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'KycGrid', key);
    }
    refreshClicked = () => {
        this.props.loadItems();
    }

    getGridCols = () => {
        let cols = [
            { headerName: this.label("Type"), field: "type", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, width: 100, minWidth: 100, maxWidth: 100 },
            { headerName: this.label("Name"), field: "name", sortable: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { headerName: this.label("City"), field: "city", sortable: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
        ]

        return cols;
    }

    onGridReady = (params) => {
        this.gridApi = params.api;

    };
    deselectAll = () => {
        if (this.gridApi) {
            this.gridApi.deselectAll()
        }
    }
    setHeigthParam = (height) => {
        this.props.saveHeightParam(height);
    }
    setWidthParam = (width) => {
        this.props.saveWidthParam(width);
    }
    //#region Grid/Button handlers

    onSelect = async (dataitem) => {
        this.setState({
            selectedIdRecord: dataitem.id,
        });
    }

    //#endregion

    render() {
        const loading = this.props.loading;
        const gridHeight = this.props.contentHeight + 63;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='kyc'>
                <MainContent onHeightRecorded={this.setHeigthParam} onWidthRecorded={this.setWidthParam} style={{ margin: '0 5px' }}>
                    {loading ? (
                        <div className="loader-content" >
                            <Spin size="large" />
                            <p>{this.label("Loading")}</p>
                        </div>
                    ) : (
                        <>
                            <AgGridWithState height={gridHeight} ShowGroupPanel={true}
                                lang={this.props.curLanguage}
                                onReady={this.onGridReady}
                                onItemSelected={this.onSelect}
                                columnDefinitions={columnDefinitions}
                                data={this.props.items}
                                onRefresh={this.refreshClicked}
                                labels={this.props.labels}
                            >
                            </AgGridWithState>
                        </>
                    )}
                </MainContent>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state[constants.NAME].loading,
        items: state[constants.NAME].items,
        curLanguage: uistate.selectors.curLanguage(state),
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {
        setLoading,
        loadItems,
        loadLabels: uistate.actions.loadLabels,
        saveHeightParam: uistate.actions.saveHeightParam,
        saveWidthParam: uistate.actions.saveWidthParam,
    })(KycGrid);